/**
 * Who is making the commit (spec §15: every human commit carries `{"by":"profile:<id>"}`; solo modes
 * stamp it too — the UI never shows it there, but history stays uniform).
 */
let actor = "profile:unknown";

export function setActor(profileId: string | null | undefined): void {
  actor = profileId ? `profile:${profileId}` : "profile:unknown";
}

export function commitMessage(extra?: Record<string, unknown>): string {
  return JSON.stringify({ by: actor, ...extra });
}

/** The acting profile id, or null before the session is known. */
export function actorProfile(): string | null {
  return actor === "profile:unknown" ? null : actor.slice("profile:".length);
}
